import Cookies from 'js-cookie'

const COOKIE_KEY = 'COOKIE_ACCEPTED'
export enum COOKIE_VALUE {
    ACCEPTED = 'accept',
    DECLINE = 'decline'
}


const cookieService = {
    isAccepted: () => Cookies.get(COOKIE_KEY) === COOKIE_VALUE.ACCEPTED,
    accept: () => Cookies.set(COOKIE_KEY, COOKIE_VALUE.ACCEPTED),
    decline: () => Cookies.set(COOKIE_KEY, COOKIE_VALUE.DECLINE),
}

export default cookieService